<div class="web-links-container">
  <div class="web-links-header">
    <div *ngIf="!isEpic">
      <strong>Подзадачи</strong>
      <nb-icon icon="plus-circle-outline" (click)="openForm()"></nb-icon>
    </div>
    <div *ngIf="isEpic">
      <strong>Задачи в этом эпике</strong>
      <nb-icon icon="plus-circle-outline" (click)="openForm()"></nb-icon>
    </div>
  </div>

  <app-issue-subtask-list [items]="store.items$" [store]="store"></app-issue-subtask-list>

  <form [formGroup]="form" *ngIf="showForm" (ngSubmit)="onSubmit()">
    <div class="form-flex">
      <nb-form-field *ngIf="isEpic">
        <nb-icon nbPrefix [icon]="selectedIssueType.icon" pack="jira"></nb-icon>
        <nb-select formControlName="type" placeholder="Тип задачи" (selectedChange)="changeIssueType($event)">
          <nb-option *ngFor="let type of issueTypes" [value]="type.id">
            {{ type.header }}
          </nb-option>
        </nb-select>
      </nb-form-field>
      <input #headerInput nbInput fullWidth formControlName="header" placeholder="Что нужно сделать?"/>
    </div>
    <div class="web-link-buttons">
      <button nbButton size="small" status="primary" [disabled]="!form.valid">Создать</button>
      <button nbButton size="small" status="basic" type="button" (click)="closeForm()">Отмена</button>
    </div>
  </form>

</div>
